module.exports = __webpack_public_path__ + "img/logo_hk.1a0e3bb8.png";